import type { ReferralAttributionStatus, ReferralOwnerType } from '@manaro/contracts'
import type { BadgeTone } from '@/shared/ui/badge.tsx'

export const OWNER_TYPE_TABS: Array<{ value: ReferralOwnerType; label: string }> = [
  { value: 'business', label: 'Бизнесы' },
  { value: 'user', label: 'Пользователи' },
]

export const ACCOUNT_KIND_LABELS: Record<ReferralOwnerType, string> = {
  business: 'Бизнес',
  user: 'Пользователь',
}

export const STATUS_LABELS: Record<ReferralAttributionStatus, string> = {
  pending: 'Ждёт действия',
  active: 'Активен',
  reverted: 'Отменён',
}

export const STATUS_TONES: Record<ReferralAttributionStatus, BadgeTone> = {
  pending: 'info',
  active: 'brand',
  reverted: 'neutral',
}

const SOURCE_LABELS: Record<string, string> = {
  registration: 'При регистрации',
  business_creation: 'При создании бизнеса',
  claim: 'Ввёл код после регистрации',
}

const SUSPICIOUS_REASON_LABELS: Record<string, string> = {
  same_ip_burst: '3+ приглашения с одного IP за сутки',
}

export const sourceLabel = (source: string): string => SOURCE_LABELS[source] ?? source

export const suspiciousReasonLabel = (reason: string | null): string =>
  reason ? (SUSPICIOUS_REASON_LABELS[reason] ?? reason) : 'Причина не указана'
